/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Authentication API
 * An API to use to authenticate users
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Authentication type
 * @export
 * @enum {string}
 */
export enum AuthType {
    BankId = 'BANK_ID',
    Siths = 'SITHS'
}

export function AuthTypeFromJSON(json: any): AuthType {
    return AuthTypeFromJSONTyped(json, false);
}

export function AuthTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthType {
    return json as AuthType;
}

export function AuthTypeToJSON(value?: AuthType | null): any {
    return value as any;
}

